import { MapPin, Phone, Mail } from "lucide-react";

const LOGO =
    "https://customer-assets.emergentagent.com/job_2e4f9de3-0bb7-4f65-a448-938d9d2f8e50/artifacts/j174pbvz_Opteris%20PNG.png";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#1a1a1a] text-white pt-20 pb-10 relative overflow-hidden"
        >
            <div className="absolute -top-40 right-0 w-96 h-96 rounded-full bg-[#ea4d87]/20 blur-3xl pointer-events-none" />
            <div className="absolute -bottom-40 -left-20 w-96 h-96 rounded-full bg-[#f4861c]/15 blur-3xl pointer-events-none" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                <div className="grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <img
                            src={LOGO}
                            alt="Creaciones Opteris"
                            className="h-16 w-auto object-contain"
                        />
                        <p className="mt-5 text-white/60 leading-relaxed text-sm max-w-md">
                            Tu aliado estratégico en papelería y suministros de
                            oficina. Operamos al por mayor y menor con logística
                            robusta y calidad garantizada.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-xs font-bold uppercase tracking-widest text-white/50 mb-5">
                            Navegación
                        </div>
                        <ul className="space-y-3 text-sm">
                            {[
                                { href: "#nosotros", label: "Nosotros" },
                                { href: "#servicios", label: "Productos" },
                                { href: "#clientes", label: "Clientes" },
                                { href: "#testimonios", label: "Testimonios" },
                                { href: "#contacto", label: "Contacto" },
                            ].map((l) => (
                                <li key={l.href}>
                                    <a
                                        href={l.href}
                                        className="text-white/75 hover:text-[#f4861c] transition-colors"
                                        data-testid={`footer-link-${l.label.toLowerCase()}`}
                                    >
                                        {l.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="text-xs font-bold uppercase tracking-widest text-white/50 mb-5">
                            Contacto
                        </div>
                        <ul className="space-y-4 text-sm">
                            <li className="flex items-start gap-3 text-white/80">
                                <MapPin
                                    size={16}
                                    className="text-[#f4861c] mt-0.5 flex-shrink-0"
                                />
                                <span>
                                    Esteban Alatorre 1288-A int. 4, San Juan
                                    Bosco C.P. 44730, Guadalajara, Jalisco,
                                    México.
                                </span>
                            </li>
                            <li>
                                <a
                                    href="tel:3321685009"
                                    className="flex items-center gap-3 text-white/80 hover:text-[#f4861c] transition-colors"
                                >
                                    <Phone
                                        size={16}
                                        className="text-[#f4861c]"
                                    />
                                    33 2168 5009
                                </a>
                            </li>
                            <li>
                                <a
                                    href="mailto:contacto@creacionesopteris.com"
                                    className="flex items-center gap-3 text-white/80 hover:text-[#f4861c] transition-colors break-all"
                                >
                                    <Mail
                                        size={16}
                                        className="text-[#f4861c]"
                                    />
                                    contacto@creacionesopteris.com
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom bar */}
                <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-white/50">
                    <div data-testid="footer-copyright">
                        © {new Date().getFullYear()} Creaciones Opteris. Todos
                        los derechos reservados.
                    </div>
                    <div>Guadalajara, Jalisco · México</div>
                </div>
            </div>
        </footer>
    );
}
